import { MarketplaceUser } from 'models/types/Marketplace';
import { AnyAction } from 'redux';
import { createActions } from 'reduxsauce';

interface MarketplaceActionTypes {
  GET_USER: 'GET_USER';
  GET_USER_SUCCESS: 'GET_USER_SUCCESS';
  GET_USER_ADDRESS: 'GET_USER_ADDRESS';
  GET_USER_ADDRESS_SUCCESS: 'GET_USER_ADDRESS_SUCCESS';
  GET_CATEGORY: 'GET_CATEGORY';
  GET_CATEGORY_SUCCESS: 'GET_CATEGORY_SUCCESS';
  GET_CART_DETAILS: 'GET_CART_DETAILS';
  GET_CART_DETAILS_SUCCESS: 'GET_CART_DETAILS_SUCCESS';
  GET_SUPPORTED_COUNTRIES: 'GET_SUPPORTED_COUNTRIES';
  GET_SUPPORTED_COUNTRIES_SUCCESS: 'GET_SUPPORTED_COUNTRIES_SUCCESS';
  GET_MARKETPLACE_THEME: 'GET_MARKETPLACE_THEME';
  GET_MARKETPLACE_THEME_SUCCESS: 'GET_MARKETPLACE_THEME_SUCCESS';
  GET_LIST_SOFTWARE_SUBSCRIPTION: 'GET_LIST_SOFTWARE_SUBSCRIPTION';
  GET_LIST_SOFTWARE_SUBSCRIPTION_SUCCESS: 'GET_LIST_SOFTWARE_SUBSCRIPTION_SUCCESS';
  GET_ALL_MARKETPLACE_REQUESTS_OPEN: 'GET_ALL_MARKETPLACE_REQUESTS_OPEN';
  GET_ALL_MARKETPLACE_REQUESTS_OPEN_SUCCESS: 'GET_ALL_MARKETPLACE_REQUESTS_OPEN_SUCCESS';
  GET_ALL_MARKETPLACE_REQUESTS_OPEN_FAIL: 'GET_ALL_MARKETPLACE_REQUESTS_OPEN_FAIL';
  GET_ALL_MARKETPLACE_REQUESTS_CLOSED: 'GET_ALL_MARKETPLACE_REQUESTS_CLOSED';
  GET_ALL_MARKETPLACE_REQUESTS_CLOSED_SUCCESS: 'GET_ALL_MARKETPLACE_REQUESTS_CLOSED_SUCCESS';
  GET_ALL_MARKETPLACE_REQUESTS_CLOSED_FAIL: 'GET_ALL_MARKETPLACE_REQUESTS_CLOSED_FAIL';
  GET_ALL_MARKETPLACE_APPROVAL_OPEN: 'GET_ALL_MARKETPLACE_APPROVAL_OPEN';
  GET_ALL_MARKETPLACE_APPROVAL_OPEN_SUCCESS: 'GET_ALL_MARKETPLACE_APPROVAL_OPEN_SUCCESS';
  GET_ALL_MARKETPLACE_APPROVAL_OPEN_FAIL: 'GET_ALL_MARKETPLACE_APPROVAL_OPEN_FAIL';
  GET_ALL_MARKETPLACE_APPROVAL_CLOSED: 'GET_ALL_MARKETPLACE_APPROVAL_CLOSED';
  GET_ALL_MARKETPLACE_APPROVAL_CLOSED_SUCCESS: 'GET_ALL_MARKETPLACE_APPROVAL_CLOSED_SUCCESS';
  GET_ALL_MARKETPLACE_APPROVAL_CLOSED_FAIL: 'GET_ALL_MARKETPLACE_APPROVAL_CLOSED_FAIL';
  SET_REQUESTS_DATE_RANGE: 'SET_REQUESTS_DATE_RANGE';
  SET_INC_DATE_RANGE: 'SET_INC_DATE_RANGE';
  SET_APPROVAL_DATE_RANGE: 'SET_APPROVAL_DATE_RANGE';
  SET_APPROVER: 'SET_APPROVER';
  UPDATE_TICKET_STATUS: "UPDATE_TICKET_STATUS";
}

interface MarketplaceActions {
  getUser: (email: string) => AnyAction;
  getUserSuccess: (user: MarketplaceUser) => AnyAction;
  getUserAddress: (id: string) => AnyAction;
  getUserAddressSuccess: (userAddress: any) => AnyAction;
  getCategory: (params: any) => AnyAction;
  getCategorySuccess: (category: any) => AnyAction;
  getCartDetails: (id: string, locale: string) => AnyAction;
  getCartDetailsSuccess: (cart: any) => AnyAction;
  getSupportedCountries: (id: string) => AnyAction;
  getSupportedCountriesSuccess: (supportedCountries: any[]) => AnyAction;
  getMarketplaceTheme: () => AnyAction;
  getMarketplaceThemeSuccess: (marketplaceTheme: any) => AnyAction;
  getListSoftwareSubscription: (email: string) => AnyAction;
  getListSoftwareSubscriptionSuccess: (softwareData: any[]) => AnyAction;
  getAllMarketplaceRequestsOpen: (params: any) => AnyAction;
  getAllMarketplaceRequestsOpenSuccess: (marketplaceRequestsOpen: any) => AnyAction;
  getAllMarketplaceRequestsOpenFail: () => AnyAction;
  getAllMarketplaceRequestsClosed: (params: any) => AnyAction;
  getAllMarketplaceRequestsClosedSuccess: (marketplaceRequestsClosed: any) => AnyAction;
  getAllMarketplaceRequestsClosedFail: () => AnyAction;
  getAllMarketplaceApprovalOpen: (params: any) => AnyAction;
  getAllMarketplaceApprovalOpenSuccess: (marketplaceApprovalOpen: any) => AnyAction;
  getAllMarketplaceApprovalOpenFail: () => AnyAction;
  getAllMarketplaceApprovalClosed: (params: any) => AnyAction;
  getAllMarketplaceApprovalClosedSuccess: (marketplaceApprovalClosed: any) => AnyAction;
  getAllMarketplaceApprovalClosedFail: () => AnyAction;
  setRequestsDateRange: (dateRange: any[]) => AnyAction;
  setIncDateRange: (dateRange: any[]) => AnyAction;
  setApprovalDateRange: (dateRange: any[]) => AnyAction;
  setApprover: (approver: any[]) => AnyAction;
  updateTicketStatus: (ticketStatusChange: string) => AnyAction;
}

const { Types, Creators } = createActions<
  MarketplaceActionTypes,
  MarketplaceActions
>({
  getUser: ['email'],
  getUserSuccess: ['user'],
  getUserAddress: ['id'],
  getUserAddressSuccess: ['userAddress'],
  getCategory: ['params'],
  getCategorySuccess: ['category'],
  getCartDetails: ['id', 'locale'],
  getCartDetailsSuccess: ['cart'],
  getSupportedCountries: ['id'],
  getSupportedCountriesSuccess: ['supportedCountries'],
  getMarketplaceTheme: [],
  getMarketplaceThemeSuccess: ['marketplaceTheme'],
  getListSoftwareSubscription: ['email'],
  getListSoftwareSubscriptionSuccess: ['softwareData'],
  getAllMarketplaceRequestsOpen: ['params'],
  getAllMarketplaceRequestsOpenSuccess: ['marketplaceRequestsOpen'],
  getAllMarketplaceRequestsOpenFail: [],
  getAllMarketplaceRequestsClosed: ['params'],
  getAllMarketplaceRequestsClosedSuccess: ['marketplaceRequestsClosed'],
  getAllMarketplaceRequestsClosedFail: [],
  getAllMarketplaceApprovalOpen: ['params'],
  getAllMarketplaceApprovalOpenSuccess: ['marketplaceApprovalOpen'],
  getAllMarketplaceApprovalOpenFail: [],
  getAllMarketplaceApprovalClosed: ['params'],
  getAllMarketplaceApprovalClosedSuccess: ['marketplaceApprovalClosed'],
  getAllMarketplaceApprovalClosedFail: [],
  setRequestsDateRange: ['requestsDateRange'],
  setIncDateRange: ['incDateRange'],
  setApprovalDateRange: ['approvalDateRange'],
  setApprover: ['approver'],
  updateTicketStatus: ['ticketStatusChange'],
});

export const MarketplaceTypes = Types;
export default Creators;
